export default __webpack_public_path__ + "static/media/left_bottom_image_mobile.fecbabe7.png";